/* eslint no-shadow: 0 */
import mbcSVC from '@/services/mbc_svc';
import ssoSVC from '@/services/sso_svc';
import comSVC from '@/services/com_svc';
import trdSVC from '@/services/trd_svc';
import rmuSVC from '@/services/rmu_svc';
import nanshanSVC from '@/services/nanshan_svc';
import i18n from '@/i18n/index';
import { companyid } from '@/config';
import commonTool from '../tools/commonTool';

export const namespaced = true;

export const state = {
  // 取得MemberSourceSetting資料的Promise
  memberSourceSettingPromise: null,
  // 取得MemberSourcePair資料的Promise
  memberSourcePairPromise: null,
  // 從API取得的 RedirectUrl
  apiRedirectUrl: '',
  accountID: '',
  mobileAccountID: '',
  // callAPI 完成
  callMemberSourceSettingDone: false,
  // 客製化CSS Begin
  logoPic: '',
  pcMainBgImg: '',
  bkgrdType: '',
  bkgrdColor: '',
  bkgrdValue: '',
  fontColor: '',
  panelBkgrdColor: '',
  btnColor: '',
  btnFontColor: '',
  btnBdrFontColor: '',
  ssoVersion: '',
  // 客製化CSS End
  normalRegrType: '',
  loginLimitCnt: '',
  isRegistRedirect: false,
  RegistRedirectUrl: '',
  accountType: '',
  identifySource: '',
  models: [],
  customModels: [],
  answers: [],
  customAnswers: [],
  validatePasswordDone: true,
  callPutCustomerdataupdateDone: true,
  callPostCustomerDataAddDone: true,
  callPostCustomerdatabindDone: true,
  password: null,
  updatePassword: false,
  updateAddress: false,
  countrys: [],
  twCityList: [],
  cnProvinceList: [],
  isReadedPrivacyPolicy: false,
  isAgreedPrivacyPolicy: false,
  privacyFooterPositionCss: 'position-fixed',
  trdLoginData: null,
  didSignup: false,
  userVerifyType: '',
  isFromLogin: false,
  isFromVerifyMobile: false,
  verifierAccount: undefined,
  doVerifierAccount: false,
  callingVerifierAccount: false,
  clickBtn: false,
  continueDoSaveData: false,
  trdPartyLoginType: '',
  verifyMobileData: null,
  memberAcntNo: '',
  loginVerifyApi: '',
  isCreateMember: false,
  isProduction: true,
  createMemberApi: '',
  openID: undefined,
  hidenRegister: false,
  hideView: false,
  reaccountmobile: '',
  mobileData: null,
  havePasword: true,
  unbind: false,
  fullMobileNo: null,
  email: '',

  // 自動登入
  doAutoLogin: false,
  autoLoginAccount: undefined,
  autoLoginPassword: undefined,

  skipSignUp: false,
  getSignUpDataDone: false,
  isCombineAccountNeedPassword: false,
  channelID: '',
  liffId: '',
  officialAccount: '',

  // SSO2.0
  mobileEditable: true,
  isHiddenFirstSend: false,
  isHiddenGenerally: false,
  isPasswordReset: false,
  isShowPasswordReset: false,
  memberId: '',
  loginFromLineID: null,
  ssoType: 0, // 0:一般登入註冊,1:快速登入註冊
  ssoV2PageNow: 'loginPage',
  // privacyPolicyPage-條款頁
  // loginPage-登入頁
  // commonLoginPage-一般登入頁
  // resetPasswordPage-重新設置密碼頁
  // setPasswordPage-設置密碼頁
  // verifyPage-驗證分頁
  // thirdPartyLoginVerifyPage 第三方登入驗證身分頁
  // privacyEasyPolicyPage-寬鬆條款頁
  // bindingAgreement-LINE條款
  // verifyPageAfterEmail 輸入Email後須輸入手機的頁面
  // crmVerifyPage 帳號驗證需輸入手機的頁面
  ssoV2Type: '',
  // commonLogin 走一般註冊登入流程
  // reaccount-歸戶
  // fastLogin 走快速註冊登入流程
  // signUp 走註冊流程(沒有註冊過)
  // thirdPartyLogin 第三方登入流程
  // forgotPassword 忘記密碼
  // crmLogin 外部帳號未驗證登入流程
  loginFailedCount: '',
  rulePolicy: 0,
  isLineBrowser: false,
  isHaveProfileID: false,

  // 第三方登入相關參數
  lineLoginAccountSourceId: '',
  lineLoginChannelId: '',
  googleLoginAccountSourceId: '',
  googleLoginChannelId: '',
  facebookLoginAccountSourceId: '',
  facebookLoginChannelId: ''
};

export const getters = {
  isTrdLogin: (state) => {
    switch (state.normalRegrType.toLowerCase()) {
      case 'email':
        if (state.trdLoginData && state.trdLoginData.email) {
          return true;
        }
        return false;
      case 'mobile':
      case 'sms':
        if (state.trdLoginData && state.trdLoginData.mobile) {
          return true;
        }
        return false;
      default:
        if (state.trdLoginData && state.trdLoginData.accountID) {
          return true;
        }
        return false;
    }
  }
};

export const mutations = {
  setMemberSourceData(state, data) {
    state[data.id] = data.value;
  },
  setMemberSourceSetting(state, data) {
    state.accountType = data.userVerifyType;
    state.userVerifyType = data.userVerifyType;
    state.apiRedirectUrl = data.redirectUrl;
    state.logoPic = data.logoPic;
    state.bkgrdType = data.bkgrdType;
    state.bkgrdColor = data.bkgrdColor;
    state.bkgrdValue = data.bkgrdValue;
    state.fontColor = data.fontColor;
    state.panelBkgrdColor = data.panelBkgrdColor;
    state.btnColor = data.btnColor;
    state.btnFontColor = data.btnFontColor;
    state.btnBdrFontColor = data.btnBdrFontColor;
    state.normalRegrType = data.normalRegrType;
    state.trdPartyLoginType = data.trdPartyLoginType;
    state.loginLimitCnt = data.loginLimitCnt;
    state.pcMainBgImg = data.pcMainBgImg;
    state.ssoVersion = data.ssoVersion;
    state.ssoType = data.ssoType;
    state.rulePolicy = data.rulePolicy;

    state.channelID = data.channelDetail?.[0].channelID ?? state.channelID;
    state.liffId = data.channelDetail?.[0].param.find(x => x.channelParam === 'SSOLiffId')?.channelParamValue ?? state.liffId;
    state.officialAccount = data.channelDetail?.[0].param.find(x => x.channelParam === 'AccountID')?.channelParamValue ?? state.officialAccount;

    state.LoginVerifyApi = data.setttingDetl.find(s => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'loginverifyapi')?.paramValue ?? state.LoginVerifyApi;
    state.createMemberApi = data.setttingDetl.find(s => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'creatememberapi')?.paramValue ?? state.createMemberApi;
    state.RegistRedirectUrl = data.setttingDetl.find(s => s.paramType.toLowerCase() === 'regist' && s.paramCode.toLowerCase() === 'registredirecturl')?.paramValue ?? state.RegistRedirectUrl;

    state.isCreateMember = (data.setttingDetl.find(s => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'iscreatemember')?.paramValue?.toLowerCase() ?? state.isCreateMember.toString()) === 'true';
    state.isProduction = (data.setttingDetl.find(s => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'isproduction')?.paramValue?.toLowerCase() ?? state.isProduction.toString()) === 'true';
    state.isRegistRedirect = (data.setttingDetl.find(s => s.paramType.toLowerCase() === 'regist' && s.paramCode.toLowerCase() === 'isregistredirect')?.paramValue?.toLowerCase() ?? state.isRegistRedirect.toString()) === 'true';
    state.hidenRegister = (data.setttingDetl.find(s => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'hidenregister')?.paramValue?.toLowerCase() ?? state.hidenRegister.toString()) === 'true';
  },
  setBrandData(state, data) {
    state.lineLoginAccountSourceId = data.lineLoginAccountSourceId;
    state.lineLoginChannelId = data.lineLoginChannelId;
    state.googleLoginAccountSourceId = data.googleLoginAccountSourceId;
    state.googleLoginChannelId = data.googleLoginChannelId;
    state.facebookLoginAccountSourceId = data.facebookLoginAccountSourceId;
    state.facebookLoginChannelId = data.facebookLoginChannelId;
  },
  setAnswers(state, data) {
    state.answers = [];
    state.answers.push({ id: 'Name', value: data.realName });
    state.answers.push({ id: 'Nickname', value: data.name });
    state.answers.push({ id: 'Gender', value: data.gender });
    state.answers.push({ id: 'PersonalID', value: data.personalID });
    state.answers.push({ id: 'EMail', value: data.email });
    state.answers.push({ id: 'Birthday', value: data.birth.replace(/\//g, '-') });
    if (data.country === 'TW') {
      data.city = data.city?.replace(/台/, '臺');
    }
    const address = {
      zipCode: data.zipCode,
      country: data.country,
      province: data.province,
      city: data.city,
      district: data.district,
      address: data.address
    };
    state.answers.push({ id: 'Address', value: address });
    const mobile = {
      mobileCountry: data.mobileCountry,
      callingCode: data.callingCode,
      mobile: data.mobile
    };
    state.answers.push({ id: 'Mobile', value: mobile });
    state.customAnswers = data.custom;
  },
  updateAnswer(state, data) {
    if (state.answers.find(d => d.id === data.id)) {
      state.answers.find(d => d.id === data.id).value = data.value;
    } else {
      state.answers.push({ id: data.id, value: data.value });
    }
  },
  updateCustomAnswer(state, data) {
    if (state.customAnswers.find(d => d.customQuestionID === data.id)) {
      state.customAnswers.find(d => d.customQuestionID === data.id).paramValue = data.value;
    } else {
      state.customAnswers.push({ customQuestionID: data.id, paramValue: data.value });
    }
  }
};

export const actions = {
  getMemberSourceSetting({ commit, state, rootState }) {
    // 若promise不存在，建立新promise
    if (!state.memberSourceSettingPromise) {
      const params = {
        companyID: rootState.common.companyID,
        memberSourceID: rootState.common.memberSourceID
      };

      const promise = ssoSVC.getMemberSourceSetting(params).then((res) => {
        if (res.success) {
          if (!res.data[0].channelDetail?.length) {
            res.data[0].channelDetail = undefined;
          }

          // 設定MemberSource資料
          commit('setMemberSourceSetting', res.data[0]);
          // 設定公司資料
          commit('common/setCommonData', { id: 'brandNo', value: res.data[0].brandNo }, { root: true });
        }

        // 取得品牌資料
        return ssoSVC.getBrand({ brandNo: res.data[0].brandNo }).then((brandRes) => {
          commit('setBrandData', brandRes.data[0]);
          return res;
        });
      });

      // 保存promise
      commit('setMemberSourceData', { id: 'memberSourceSettingPromise', value: promise });
    }

    // 回傳promise
    return state.memberSourceSettingPromise;
  },
  getMemberSourcePair({ commit, state, rootState }) {
    // 若promise不存在，建立新promise
    if (!state.memberSourcePairPromise) {
      const params = {
        pairNo: rootState.common.memberSourcePairNo
      };

      const promise = ssoSVC.getMemberSourcePair(params).then((res) => {
        if (res.success) {
          // 檢查是否有綁定渠道的資料
          if (res.data[0].bindingMemberSoourceInfo?.channelDetail) {
            res.data[0].mainMemberSourceInfo.channelDetail = res.data[0].bindingMemberSoourceInfo.channelDetail;
          } else {
            res.data[0].mainMemberSourceInfo.channelDetail = undefined;
          }

          // 設定MemberSource資料
          commit('setMemberSourceSetting', res.data[0].mainMemberSourceInfo);
          // 設定公司資料
          commit('common/setCommonData', { id: 'companyID', value: res.data[0].companyId }, { root: true });
          commit('common/setCommonData', { id: 'memberSourceID', value: res.data[0].mainMemberSourceInfo.memberSourceId }, { root: true });
          commit('common/setCommonData', { id: 'bindingMemberSourceID', value: res.data[0].bindingMemberSoourceInfo?.memberSourceId || '' }, { root: true });
          commit('common/setCommonData', { id: 'brandNo', value: res.data[0].brandNo }, { root: true });
          commit('setBrandData', res.data[0]);
        }
        return res;
      });

      // 保存promise
      commit('setMemberSourceData', { id: 'memberSourcePairPromise', value: promise });
    }

    // 回傳promise
    return state.memberSourcePairPromise;
  },
  postAccountInfo({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountID: payload.accountID,
      password: payload.password
    };
    return mbcSVC.postAccountInfo(body);
  },
  postAccountInfo20({ rootState }, payload) {
    const body = {
      companyId: rootState.common.companyID,
      memberSourceID: payload.accountType === 'LineBind' ? rootState.common.bindingMemberSourceID : rootState.common.memberSourceID,
      accountId: payload.accountID,
      password: payload.password,
      accountType: payload.accountType
    };
    return mbcSVC.postAccountInfo20(body);
  },
  putPassword({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberAcntNo: payload.memberAcntNo,
      password: payload.password
    };
    return mbcSVC.putPassword(body);
  },
  putPasswordByMemberIDAccountType({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberID: payload.memberID,
      accountType: payload.accountType,
      password: payload.password
    };
    return mbcSVC.putPassword(body);
  },
  postLogin({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      memberAcntNo: payload.memberAcntNo,
      memberID: payload.memberID,
      device: payload.device
    };
    return ssoSVC.postLogin(body);
  },
  postDigest({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      payload
    };
    return ssoSVC.postDigest(body);
  },
  postVerifyCode({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      memberAcntNo: payload.memberAcntNo,
      verifyType: payload.verifyType,
      verifyTarget: payload.verifyTarget,
      codeType: payload.codeType
    };
    return ssoSVC.postVerifyCode(body);
  },
  postMobileVerifyCode({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      verifyTarget: payload
    };
    return ssoSVC.postMobileVerifyCode(body);
  },
  getMobileVerifySetting({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      paramCode: payload
    };
    return ssoSVC.getMobileVerifySetting(body);
  },
  postMobileVerifycodeVerifier({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      verifyTarget: payload.verifyTarget,
      verifyCode: payload.verifyCode
    };
    return ssoSVC.postMobileVerifycodeVerifier(body);
  },
  postVerifyCodeVerifier({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      verifyTarget: payload.verifyTarget,
      verifyCode: payload.verifyCode
    };
    return ssoSVC.postVerifyCodeVerifier(body);
  },
  postAccesstokenEditcode({ dispatch, rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      editcode: payload
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = { digest: res.data[0].digest };
        return ssoSVC.postAccesstokenEditcode(body, headers);
      }
      return res;
    });
  },
  postAccesstokenCode({ dispatch, rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      code: payload
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = { digest: res.data[0].digest };
        return ssoSVC.postAccesstokenCode(body, headers);
      }
      return res;
    });
  },
  postLineuserid(_, payload) {
    const body = {
      code: payload.code,
      companyID: companyid,
      directURL: payload.directURL
    };
    return comSVC.postLineuserid(body);
  },
  postCheckFriend(_, payload) {
    const body = payload;

    return comSVC.postCheckFriend(body);
  },
  getCompanyPermission({ rootState }) {
    const body = {
      companyID: rootState.common.companyID
    };
    return ssoSVC.getCompanyPermission(body);
  },
  getProfileSetting({ commit, rootState }, payload) {
    const params = {
      companyID: rootState.common.companyID,
      profileID: payload.id
    };
    return ssoSVC.getProfileSetting(params).then((res) => {
      if (res.success) {
        // 設定並排續 models
        let models = res.data[0].profiles.sort((a, b) => a.modelOrder - b.modelOrder);
        // 若是為註冊頁
        if (payload.type === 'regr') {
          // 若是手機驗證流程
          if (state.verifyMobileData) {
            const mobile = {
              mobileCountry: state.verifyMobileData.mobileCountry,
              callingCode: state.verifyMobileData.callingCode,
              mobile: state.verifyMobileData.mobile
            };
            commit('updateAnswer', { id: 'Mobile', value: mobile });
            if (!models.find(d => d.modelID === 'Mobile')) {
              models.splice(0, 0, {
                modelID: 'Mobile',
                required: true,
                editable: false
              });
            } else {
              models.find(d => d.modelID === 'Mobile').editable = false;
            }
            if (!models.find(d => d.modelID === 'Password')) {
              models.splice(1, 0, {
                modelID: 'Password',
                required: true,
                editable: true
              });
            }
          }
          // 若是第3方登入
          if (state.trdLoginData) {
            if (state.trdLoginData.email) {
              commit('updateAnswer', { id: 'EMail', value: state.trdLoginData.email });
            }
            if (state.trdLoginData.mobile) {
              commit('updateAnswer', { id: 'Mobile', value: state.trdLoginData.mobile });
            }
            switch (state.accountType) {
              // 若有從第3方取得 email，用它來更新 email 欄位
              case 'Email':
                if (state.trdLoginData.email) {
                  commit('setMemberSourceData', { id: 'identifySource', value: state.trdLoginData.email });
                  if (models.find(d => d.modelID === 'EMail')) {
                    models.find(d => d.modelID === 'EMail').editable = false;
                  }
                } else if (!models.find(d => d.modelID === 'EMail')) {
                  models.splice(0, 0, {
                    modelID: 'EMail',
                    required: true,
                    editable: false
                  });
                }
                break;
              case 'Mobile':
                if (state.trdLoginData.mobile) {
                  commit('setMemberSourceData', { id: 'identifySource', value: state.trdLoginData.mobile });
                  if (models.find(d => d.modelID === 'Mobile')) {
                    models.find(d => d.modelID === 'Mobile').editable = false;
                  }
                } else if (!models.find(d => d.modelID === 'Mobile')) {
                  models.splice(0, 0, {
                    modelID: 'Mobile',
                    required: true,
                    editable: false
                  });
                }
                break;
              default:
                break;
            }
            // 若第3方資訊有名稱則使用，無則使用第3方之 email、mobile
            if (state.trdLoginData.name) {
              commit('updateAnswer', { id: 'Nickname', value: state.trdLoginData.name });
            } else {
              switch (state.accountType) {
                // 若有從第3方取得 email、mobile，用它來更新 Nickname 欄位
                case 'Email':
                  if (state.trdLoginData.email) {
                    commit('updateAnswer', { id: 'Nickname', value: state.trdLoginData.email });
                  }
                  break;
                case 'Mobile':
                  if (state.trdLoginData.mobile) {
                    commit('updateAnswer', { id: 'Nickname', value: state.trdLoginData.mobile });
                  }
                  break;
                default:
                  break;
              }
            }
            if (state.trdLoginData.birthday) {
              commit('updateAnswer', { id: 'Birthday', value: state.trdLoginData.birthday });
            }
            // 手機驗證
          } else {
            // 若 accountType 為 EMail 或 Mobile 但沒有 EMail 或 Mobile 的輸入框則新增 EMail 或 Mobile 的輸入框
            switch (state.accountType) {
              case 'Email':
                if (!models.find(d => d.modelID === 'EMail')) {
                  models.splice(0, 0, {
                    modelID: 'EMail',
                    required: true,
                    editable: true
                  });
                }
                break;
              case 'Mobile':
                if (!models.find(d => d.modelID === 'Mobile')) {
                  models.splice(0, 0, {
                    modelID: 'Mobile',
                    required: true,
                    editable: true
                  });
                }
                break;
              default:
                break;
            }
            // 若沒有 Password 則新增 Password 模組
            if (!models.find(d => d.modelID === 'Password')) {
              models.splice(1, 0, {
                modelID: 'Password',
                required: true,
                editable: true
              });
            }
          }
          if (state.isCombineAccountNeedPassword) {
            models = [];
            if (!state.trdLoginData) {
              models.splice(0, 0, {
                modelID: 'Password',
                required: true,
                editable: true
              });
            }
          }
        }
        commit('setMemberSourceData', { id: 'models', value: models });
      }
      return res;
    });
  },
  // 取得客製化問題
  postCustomProfileSettingCustomProfileId({ commit, rootState }, payload) {
    let language = '';
    const browserLanguage = navigator.language;
    switch (browserLanguage) {
      case 'zh-TW':
      case 'zh-CN':
        language = browserLanguage;
        break;
      default:
        language = 'en';
        break;
    }
    const body = {
      companyID: rootState.common.companyID,
      customProfileID: payload,
      language
    };

    return mbcSVC.postCustomProfileSettingCustomProfileId(body).then((res) => {
      if (res.success) {
        res.data.forEach((element) => {
          element.ans.forEach((element2) => {
            element2.value = element2.customAnsItemID;
            element2.text = element2.ansItem;
          });
        });

        commit('setMemberSourceData', { id: 'customModels', value: res.data });
      }
      return res;
    });
  },
  getMemberAccount({ commit, rootState }, isGetAll = false) {
    const params = {
      memberID: rootState.common.memberID,
      isGetAll
    };
    const headers = {};
    if (rootState.common.accessToken) {
      headers.accessToken = rootState.common.accessToken;
    }
    return mbcSVC.getMemberAccount(params, headers).then((res) => {
      if (res.success) {
        // 設定帳號類別
        commit('setMemberSourceData', { id: 'accountType', value: res.data[0].account[0].accountType });
        // 設定 identifySource
        commit('setMemberSourceData', { id: 'identifySource', value: res.data[0].account[0].identifySource });
        // 設定 accountID
        commit('setMemberSourceData', { id: 'accountID', value: res.data[0].account[0].accountID });
        commit('setMemberSourceData', { id: 'mobileAccountID', value: res.data[0].account[0].accountID });
      }
      return res;
    });
  },
  getMemberAccountByAccountID({ commit, rootState }, accountid) {
    const params = {
      companyID: rootState.common.companyID,
      membersourceID: rootState.common.memberSourceID,
      accountID: rootState.common.accountID ? rootState.common.accountID : accountid
    };
    const headers = {};
    return mbcSVC.getMemberAccount(params, headers).then((res) => {
      if (res.success) {
        // 設定 memberAcntNo
        commit('setMemberSourceData', { id: 'memberAcntNo', value: res.data[0].account[0].memberAcntNo });
        // 取得 loginFailedCount
        commit('setMemberSourceData', { id: 'loginFailedCount', value: res.data[0].account[0].loginFailedCount + 1 });
      }
      return res;
    });
  },
  // 取得使用者維護之資訊
  postCustomerdataquery({
    commit, dispatch, rootState, state
  }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      memberID: rootState.common.memberID ? rootState.common.memberID : state.memberId,
      contactID: rootState.common.contactID ? rootState.common.contactID : undefined,
      email: payload ? payload.email : undefined,
      mobile: payload ? payload.mobile : undefined
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        if (rootState.common.accessToken) {
          headers.accessToken = rootState.common.accessToken;
        }
        return mbcSVC.postCustomerdataquery(body, headers).then((res) => {
          if (res.success) {
            commit('setAnswers', res.data[0]);
            commit('common/setCommonData', { id: 'memberID', value: res.data[0].memberID }, { root: true });
            commit('common/setCommonData', { id: 'contactID', value: res.data[0].contactID }, { root: true });
          }
          return res;
        });
      }
      return res;
    });
  },
  // 更新使用者維護之資訊
  putCustomerdataupdate({
    commit, dispatch, rootState, state
  }) {
    commit('setMemberSourceData', { id: 'callPutCustomerdataupdateDone', value: false });
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      memberID: rootState.common.memberID,
      contactID: rootState.common.contactID
    };
    commonTool.setModelsToBody(body, state);
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          accessToken: rootState.common.accessToken,
          digest: res.data[0].digest
        };
        return mbcSVC.putCustomerdataupdate(body, headers).then((res2) => {
          commit('setMemberSourceData', { id: 'callPutCustomerdataupdateDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 取得國家列表
  getCountrys({ commit }) {
    return ssoSVC.getCountrys().then((res) => {
      const notCountry = 'ANO|ASIA|EU|EUR|MIDEAST|NAMER|SAMER';
      const notCountryArray = notCountry.split('|');
      const isCountry = res.data.filter((d) => {
        if (notCountry.indexOf(d.country) > -1) {
          for (let index = 0; index < notCountryArray.length; index += 1) {
            const element = notCountryArray[index];
            if (d.country === element) {
              return false;
            }
          }
        }
        return true;
      });
      commit('setMemberSourceData', { id: 'countrys', value: isCountry });
    });
  },
  // 取得台灣縣市區列表
  getzipcode({ commit }) {
    return ssoSVC.getzipcode().then((res) => {
      commit('setMemberSourceData', { id: 'twCityList', value: res.data });
    });
  },
  // 取得取得中國省市區列表
  getCNZipData(_, payload) {
    const params = {
      pid: payload
    };
    return trdSVC.getCNZipData(params);
  },
  // 新增使用者
  postCustomerDataAdd({
    commit, dispatch, rootState, state
  }) {
    // commit('setMemberSourceData', { id: 'callPostCustomerDataAddDone', value: false });
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountType: state.trdLoginData ? state.trdLoginData.accountType : state.accountType,
      identifySource: state.identifySource,
      verify: true
    };

    if (state.accountType === 'Mobile') {
      body.activate = true;
    }
    if (state.trdLoginData) {
      if (state.trdLoginData.email) {
        body.activate = true;
      }
    }

    // 若有 name、headImgURL 則使用之
    if (state.trdLoginData && state.trdLoginData.name) {
      body.name = state.trdLoginData.name;
    }
    if (state.trdLoginData && state.trdLoginData.headImgURL) {
      body.headImgURL = state.trdLoginData.headImgURL;
    }

    commonTool.setModelsToBody(body, state);

    // 第3方登入使用 accountID 作為帳號
    if (state.trdLoginData) {
      body.accountID = state.trdLoginData.accountID;
      // 非第3方登入使用 identifySource 作為帳號
    } else {
      body.accountID = body.identifySource;
    }
    commit('setMemberSourceData', { id: 'accountID', value: body.accountID });


    // 若沒有名稱，則根據 state.accountType 使用 Email、Mobile、AccountID 做為名稱
    if (!body.name) {
      switch (state.accountType) {
        case 'Mobile':
          if (body.mobile) {
            body.name = body.mobile.substring(0, 50);
          }
          break;
        case 'Email':
          body.name = body.email.substring(0, 50);
          break;
        default:
          body.name = body.accountID.substring(0, 50);
          break;
      }
    }
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        return mbcSVC.postCustomerDataAdd(body, headers).then((res2) => {
          if (res2.success) {
            commit('common/setCommonData', { id: 'memberID', value: res2.data[0].memberID }, { root: true });
            commit('common/setCommonData', { id: 'contactID', value: res2.data[0].contactID }, { root: true });
          }
          commit('setMemberSourceData', { id: 'callPostCustomerDataAddDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 新增使用者
  postCustomerDataAddV2({
    commit, dispatch, rootState, state
  }) {
    const mobile = state.mobileData;
    // commit('setMemberSourceData', { id: 'callPostCustomerDataAddDone', value: false });
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountType: state.trdLoginData ? state.trdLoginData.accountType : state.accountType,
      identifySource: state.fullMobileNo,
      mobile: mobile.mobile.toString(),
      callingCode: mobile.callingCode.toString(),
      mobileCountry: mobile.mobileCountry.toString(),
      email: state.email,
      verify: true
    };
    if (state.accountType === 'Mobile' || state.accountType === 'Email') {
      body.activate = true;
    }
    if (state.trdLoginData) {
      if (state.trdLoginData.email) {
        body.activate = true;
      }
    }
    // 若有 name、headImgURL 則使用之
    if (state.trdLoginData && state.trdLoginData.name) {
      body.name = state.trdLoginData.name;
    }
    if (state.trdLoginData && state.trdLoginData.headImgURL) {
      body.headImgURL = state.trdLoginData.headImgURL;
    }

    commonTool.setModelsToBody(body, state);

    // 第3方登入使用 accountID 作為帳號
    if (state.trdLoginData) {
      body.accountID = state.trdLoginData.accountID;
      // 非第3方登入使用 identifySource 作為帳號
    } else {
      body.accountID = state.accountID;
    }
    commit('setMemberSourceData', { id: 'accountID', value: body.accountID });

    // 若沒有名稱，則根據 state.accountType 使用 Email、Mobile、AccountID 做為名稱
    if (!body.name || body.name === undefined) {
      switch (state.accountType) {
        case 'Mobile':
          if (body.mobile) {
            body.name = body.mobile.substring(0, 50);
          }
          break;
        case 'Email':
          body.name = body.email.substring(0, 50);
          break;
        default:
          body.name = body.accountID.substring(0, 50);
          break;
      }
    }
    body.password = state.password;
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        return mbcSVC.postCustomerDataAdd(body, headers).then((res2) => {
          if (res2.success) {
            commit('common/setCommonData', { id: 'memberID', value: res2.data[0].memberID }, { root: true });
            commit('common/setCommonData', { id: 'contactID', value: res2.data[0].contactID }, { root: true });
          }
          commit('setMemberSourceData', { id: 'callPostCustomerDataAddDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 新增使用者綁定
  // 2020/11/11 寫入一筆資料到MemberAccount(不限於綁定) 用於歸戶 openid = acccountID
  postCustomerDataBind({ commit, dispatch, rootState }, {
    openid,
    identifysource,
    type = 'LineBind',
    memberSourceID = rootState.common.memberSourceID,
    isSubscribe = true
  }) {
    commit('setMemberSourceData', { id: 'callPostCustomerdatabindDone', value: false });
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID,
      openID: openid,
      accountType: type,
      identifySource: identifysource,
      isSubscribe,
      memberID: rootState.common.memberID ? rootState.common.memberID : undefined
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        return mbcSVC.postCustomerDataBind(body, headers).then((res2) => {
          if (res2.success) {
            commit('common/setCommonData', { id: 'memberID', value: res2.data[0].memberID }, { root: true });
          }
          commit('setMemberSourceData', { id: 'callPostCustomerDataBindDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 新增綁定
  postCustomerDataBindLineBind({
    commit, dispatch, rootState, state
  }, mobile) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.bindingMemberSourceID,
      openID: state.openID,
      accountType: 'LineBind',
      identifySource: mobile,
      isSubscribe: true,
      memberID: rootState.common.memberID
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        return mbcSVC.postCustomerDataBind(body, headers).then((res2) => {
          if (res2.success) {
            commit('common/setCommonData', { id: 'memberID', value: res2.data[0].memberID }, { root: true });
          }
          commit('setMemberSourceData', { id: 'callPostCustomerDataBindDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 新增使用者綁定
  postCustomerDataBindV2({
    commit, dispatch, rootState, state
  }, obj) {
    commit('setMemberSourceData', { id: 'callPostCustomerdatabindDone', value: false });
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: obj.memberSourceID || rootState.common.memberSourceID,
      openID: obj.openID,
      accountType: obj.type,
      identifySource: state.fullMobileNo,
      isSubscribe: obj.isSubscribe,
      memberID: obj.memberID || rootState.common.memberID,
      password: obj.password
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = {
          digest: res.data[0].digest
        };
        return mbcSVC.postCustomerDataBind(body, headers).then((res2) => {
          if (res2.success) {
            commit('common/setCommonData', { id: 'memberID', value: res2.data[0].memberID }, { root: true });
          }
          commit('setMemberSourceData', { id: 'callPostCustomerDataBindDone', value: true });
          return res2;
        });
      }
      return res;
    });
  },
  // 取得文案
  postWording({ rootState }, payload) {
    let language = '';
    let browserLanguage = '';
    let local = i18n.locale;

    if (local) {
      switch (local) {
        case 'tw':
          local = 'zh-tw';
          break;
        case 'cn':
          local = 'zh-cn';
          break;
        default:
          local = 'en';
          break;
      }
      browserLanguage = local;
    } else browserLanguage = navigator.language.toLowerCase();

    switch (browserLanguage) {
      case 'zh-tw':
      case 'zh-cn':
        language = browserLanguage;
        break;
      default:
        language = 'en';
        break;
    }

    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      language,
      paramCode: payload
    };
    return ssoSVC.postWording(body).then((res) => {
      if (res.success) {
        return res;
      }
      // 若無法取得文案則以'zh-TW'再呼叫一次
      body.language = 'zh-TW';
      return ssoSVC.postWording(body);
    });
  },
  getAccountVerifier({ rootState }, payload) {
    const params = {
      companyID: rootState.common.companyID,
      accountID: payload
    };
    return mbcSVC.getAccountVerifier(params);
  },
  postSendingContent({ rootState }, payload) {
    let language = '';
    const browserLanguage = navigator.language;
    switch (browserLanguage) {
      case 'zh-TW':
      case 'zh-CN':
        language = browserLanguage;
        break;
      default:
        language = 'en';
        break;
    }
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      language,
      emailID: payload
    };
    return comSVC.postSendingContent(body);
  },
  postEmailService({ rootState }, payload) {
    if (!payload.companyID) {
      payload.companyID = rootState.common.companyID;
    }
    if (!payload.memberSourceID) {
      payload.memberSourceID = rootState.common.memberSourceID;
    }
    return comSVC.postEmailService(payload);
  },
  putMemberAccount({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberAcntNo: payload.memberAcntNo,
      activate: payload.activate,
      verify: payload.verify
    };
    return mbcSVC.putMemberAccount(body);
  },
  postDynamicLogin({ rootState, state, dispatch }, payload) {
    if (state.isProduction) {
      payload.companyID = rootState.common.companyID;
      payload.memberSourceID = rootState.common.memberSourceID;
    }
    const body = {
      isCreateMember: state.isCreateMember,
      APIName: state.LoginVerifyApi,
      createMemberApi: state.createMemberApi,
      validData: payload
    };
    if (!state.isProduction) {
      payload.companyID = rootState.common.companyID;
      payload.memberSource = rootState.common.memberSourceID;
    }
    if (!state.isProduction) {
      return dispatch('postDigest', JSON.stringify(body)).then((res) => {
        if (res.success) {
          body.validData.digest = res.data[0].digest;
          return ssoSVC.postDynamicLogin(body);
        }
        return res;
      });
    }
    return ssoSVC.postDynamicLogin(body);
  },
  getProfileSettingByMemberSource({ rootState }, profileType) {
    const params = {
      memberSourceID: rootState.common.memberSourceID,
      profileType
    };
    return ssoSVC.getProfileSettingByMemberSource(params);
  },
  getUriBindServiceV2(_, payload) {
    const params = {
      myparam: `${payload.companyid}*${payload.membersourceid}*${payload.channelId}*${payload.redirectUrl}`,
      code: payload.code,
      state: payload.state,
      channelId: payload.channelId,
      openId: payload.openId
    };

    return mbcSVC.getUriBindServiceV2(params);
  },
  getRichMenuID({ commit, rootState }, payload) {
    const params = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.bindingMemberSourceID,
      status: payload
    };
    return rmuSVC.getRichMenuID(params).then((res) => {
      if (res.success) {
        commit('setMemberSourceData', { id: 'defaultMenu', value: res.data[0].defaultMenu });
        commit('setMemberSourceData', { id: 'categoryId', value: res.data[0].categoryId });
        commit('setMemberSourceData', { id: 'richmenuNo', value: res.data[0].richmenuNo });
      }
      return res;
    });
  },
  postMemberMenu({ rootState, state }) {
    const params = {
      memberID: rootState.common.memberID,
      richmenuNo: state.richmenuNo
    };
    return rmuSVC.postMemberMenu(params);
  },
  postMemberMenuV2({ rootState, state }) {
    const payload = {
      memberID: rootState.common.memberID,
      richmenuNo: state.richmenuNo,
      accountID: state.openID
    };
    return rmuSVC.postMemberMenuV2(payload);
  },
  postLinkMenuToUser({ state }) {
    const params = {
      accessToken: state.channelAccessToken,
      richMenuId: state.defaultMenu,
      userID: state.openID
    };
    return nanshanSVC.postLinkMenuToUser(params);
  },
  getChannel({ commit, rootState }) {
    const params = {
      companyID: rootState.common.companyID,
      channelID: state.channelID
    };
    return comSVC.getChannel(params).then((res) => {
      if (res.success) {
        commit('setMemberSourceData', { id: 'channelAccessToken', value: res.data[0].param.find(e => e.channelParam.toLowerCase() === 'channelaccesstoken').channelParamValue });
      }
      return res;
    });
  },
  getOfficialAccount({ commit }, companyid) {
    const params = {
      companyID: companyid
    };
    return comSVC.getChannel(params).then((res) => {
      if (res.success) {
        commit('setMemberSourceData', { id: 'officialAccount', value: res.data[0].param.find(e => e.channelParam === 'AccountID').channelParamValue });
      }
      return res;
    });
  },
  // 目前for SMS
  postMemberAccount({ rootState, state, dispatch }, payload) {
    const body = {
      comapnyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountType: state.accountType,
      accountID: payload.accountID,
      password: payload.password
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = { digest: res.data[0].digest };
        return mbcSVC.postMemberAccount(body, headers);
      }
      return res;
    });
  },
  // 贈送入會禮
  postJoinMemberGift({ rootState, dispatch }, payload) {
    const body = {
      memberId: rootState.common.memberID,
      memberSourceId: rootState.common.memberSourceID,
      companyId: rootState.common.companyID,
      accountId: [payload.accountID]
    };
    return dispatch('postDigest', JSON.stringify(body)).then((res) => {
      if (res.success) {
        const headers = { digest: res.data[0].digest };
        return mbcSVC.postJoinMemberGift(body, headers);
      }
      return res;
    });
  },
  postProspectiveCustomerRelease(_, { accountID, accountType }) {
    const body = {
      accountID,
      accountType
    };
    return mbcSVC.postProspectiveCustomerRelease(body);
  },
  getProspectiveCustomerRichmenuTag(_, { accountId, companyId }) {
    const params = {
      accountId,
      companyId
    };
    return mbcSVC.getProspectiveCustomerRichmenuTag(params);
  },
  getAccountMemberInfo({ rootState }, { accountId, type, callingCode }) {
    const params = {
      accountId,
      companyId: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      type,
      callingCode
    };
    return mbcSVC.getAccountMemberInfo(params);
  },
  getPageSetting({ rootState }, payload) {
    const body = { companyId: rootState.common.companyID, memberSourceId: rootState.common.memberSourceID, page: payload };
    return ssoSVC.getPageSetting(body);
  },
  postIdentifySourceAvailability({ rootState, state }, identifySource) {
    const body = {
      companyId: rootState.common.companyID,
      accountType: state.accountType,
      identifySource
    };
    return mbcSVC.postIdentifySourceAvailability(body);
  },
  getIdentifySourceExistence(_, { memberAcntNo }) {
    const params = {
      memberAcntNo
    };
    return mbcSVC.getIdentifySourceExistence(params);
  },
  putIdentifySource({ rootState }, payload) {
    const body = {
      companyId: rootState.common.companyID,
      accountType: payload.accountType,
      accountId: payload.accountID,
      password: payload.password,
      identifySource: payload.identifySource
    };
    return mbcSVC.putIdentifySource(body);
  },
  postMobileVerifyCodeAccount({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountType: payload.accountType,
      accountId: payload.accountID
    };
    return mbcSVC.postMobileVerifyCodeAccount(body);
  },
  postMobileVerifyCodeVerifierAccount({ rootState }, payload) {
    const body = {
      companyID: rootState.common.companyID,
      memberSourceID: rootState.common.memberSourceID,
      accountType: payload.accountType,
      accountId: payload.accountID,
      verifyCode: payload.verifyCode
    };
    return mbcSVC.postMobileVerifyCodeVerifierAccount(body);
  }
};
